<template>
  <div class="seller-offer-table">
    <app-table-dropdown
      :isHeaderLink="false"
      route="/contractors/item/"
      :response="response"
      :isAllClose="isAllClose"
    >
      <template #header>
        <div class="app-table-dropdown__table-header">
          <span
            class="app-table-dropdown__table-header-title col1 app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('name', sort.order, sort.field === 'name')
              )
            "
          >
            Название
            <div
              v-if="sort.field === 'name'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span
            v-if="!responsive.isSm"
            class="app-table-dropdown__table-header-title col1 app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('category', sort.order, sort.field === 'category')
              )
            "
          >
            Тип нефтепродукта
            <div
              v-if="sort.field === 'category'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('price', sort.order, sort.field === 'price')
              )
            "
          >
            Цена
            <div
              v-if="sort.field === 'price'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span class="app-table-dropdown__table-header-title">Склад</span>
          <span
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort(
                  'contractor',
                  sort.order,
                  sort.field === 'contractor'
                )
              )
            "
          >
            Организация
            <div
              v-if="sort.field === 'contractor'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>

          <!-- <span
            v-if="!responsive.isMd && $development"
            class="app-table-dropdown__table-header-title seller-offer-table__flex"
          >
            Ценовая динамика
          </span>
          <span
            v-if="!responsive.isMobile && $development"
            class="app-table-dropdown__table-header-title"
          >
            Просмотры
          </span>
          <span
            v-if="!responsive.isMobile && $development"
            class="app-table-dropdown__table-header-title"
          >
            Сделок
          </span> -->
        </div>
      </template>

      <template #row-header="{ item }">
        <div class="app-table-dropdown__row-header-default">
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item col1"
          >
            {{ item.name }}
          </div>
          <div class="app-table-dropdown__row-header-default-item">
            <div v-if="responsive.isSm" class="text-ellipsis">
              {{ item.name }}
            </div>
            <div class="text-ellipsis">{{ getCategory(item.category) }}</div>
            <div v-if="responsive.isMobile && $development">
              <app-svg-icon name="eye" class="seller-offer-table__icon-eye" />
              40
              <app-svg-icon
                name="barrel"
                class="seller-offer-table__icon-barrel"
              />
              3
            </div>
          </div>
          <div
            class="app-table-dropdown__row-header-default-item"
            v-if="item.priceType !== 'perPiece'"
          >
            <div class="seller-offer-table__margin-right">
              {{ item.pricePerTonne | price() }} руб. / т
            </div>
            <div class="app-table-dropdown__light">
              {{ item.pricePerLiter }} руб. / л
            </div>
          </div>
          <div class="app-table-dropdown__row-header-default-item" v-else>
            <div class="seller-offer-table__margin-right">
              {{ item.pricePerPiece | price() }} руб. / шт
            </div>
          </div>
          <div class="app-table-dropdown__row-header-default-item">
            <div class="seller-offer-table__margin-right">
              {{ warehouseName(item) }}
            </div>
          </div>

          <div class="app-table-dropdown__row-header-default-item">
            <div
              class="seller-offer-table__margin-right"
              v-if="item.contractor"
            >
              <div class="text-ellipsis">{{ item.contractor.name }}</div>
            </div>
          </div>

          <!-- <div
            v-if="!responsive.isMd && $development"
            class="app-table-dropdown__row-header-default-item seller-offer-table__flex"
          >
            <trend-chart
              class="seller-offer-table__chart"
              :datasets="[
                {
                  data: data,
                  smooth: true,
                  fill: true,
                },
              ]"
              :labels="{
                xLabels: ['05.08.20', '17.08.20'],
              }"
              :min="0"
              :max="8"
              :interactive="true"
              @mouse-move="onMouseMove"
            ></trend-chart>
            {{ res }}%
          </div>
          <div
            v-if="!responsive.isMobile && $development"
            class="app-table-dropdown__row-header-default-item"
          >
            <app-svg-icon name="eye" class="seller-offer-table__icon-eye" /> 40
          </div>
          <div
            v-if="!responsive.isMobile && $development"
            class="app-table-dropdown__row-header-default-item"
          >
            <app-svg-icon
              name="barrel"
              class="seller-offer-table__icon-barrel"
            />
            3
          </div> -->
        </div>
      </template>

      <template #row-body="{ item }">
        <seller-offers-table-item
          :response="item"
          :sort="sort"
          class="app-table-dropdown__row-body-default seller-offer-table__row"
        ></seller-offers-table-item>
      </template>

      <template #portal="{ item }">
        <seller-offers-table-portal
          :response="item"
          :sort="sort"
        ></seller-offers-table-portal>
      </template>
    </app-table-dropdown>
  </div>
</template>

<script>
import { changeSort } from '@/helpers/index';

export default {
  name: 'SellerOffersTable',
  inject: ['responsive'],
  components: {
    AppTableDropdown: () => import('@/components/common/AppTableDropdown'),
    // TrendChart: () => import('vue-trend-chart'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
    SellerOffersTableItem: () =>
      import(
        '@/pages/offers/component/sellerOffersTable/SellerOffersTableItem'
      ),
    SellerOffersTablePortal: () =>
      import(
        '@/pages/offers/component/sellerOffersTable/SellerOffersTablePortal'
      ),
  },
  props: {
    response: {
      type: Array,
      required: true,
    },
    category: {
      type: String,
      default: 'н/д',
    },
    categories: {
      type: Array,
      default() {
        return [];
      },
    },
    isAllClose: {
      type: Boolean,
    },
    sort: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    res: '-3.24',
    data: [37, 24, 42, 64, 48],
  }),
  methods: {
    warehouseName(item) {
      return item.warehouse && item.warehouse.name
        ? item.warehouse.name
        : 'Не указан склад';
    },
    changeSort,
    /**
     * Событие на движение мышкой
     * @param params
     */
    onMouseMove(params) {
      if (!params) {
        this.res = '-3.24';
      }
      if (params.index === 0) {
        this.res = 0;
      } else {
        this.res = (
          (this.data[params.index] - this.data[params.index - 1]) /
          (this.data[params.index] / this.data[params.index - 1])
        ).toFixed(2);
      }
    },
    /**
     * Получение категории
     * @param {Number} id
     */
    getCategory(id) {
      const category = this.categories.find((el) => el.uuid === id);
      if (category) {
        return category.name;
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
.seller-offer-table {
  &__flex {
    display: flex;
    flex: 0 0 30%;
    align-items: center;
    justify-content: flex-start;
    padding: 0 30px 0 0;
    font-size: rem(14);
    white-space: nowrap;
  }

  &__row {
    flex-wrap: wrap;
    padding: 10px 10px;
  }

  &__margin-right {
    margin-right: 10px;
  }

  &__icon-eye {
    width: 16px;
    height: 9px;
    fill: #aaa;
  }

  &__icon-barrel {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    fill: $color-brand-green;
  }

  &__icon-table {
    width: 16px;
    height: 16px;
    margin: 0 10px 0 0;
    vertical-align: middle;
    fill: #000;
  }

  &__chart {
    max-width: 280px;
    height: 70px;

    .fill {
      fill: rgba(150, 150, 150, 0.2);
    }

    .stroke {
      stroke: rgba(150, 150, 150, 0.5);
    }

    .active-line {
      stroke: $color-brand-green;
    }

    .x-labels {
      text {
        font-size: rem(10);
        fill: #818181;
      }
    }
  }
}
</style>
